export default {
    name: 'PhoneInput',

    props: {
        readonly: String,
        phone: String
    },

    data() {
        return {
            value: '',
        };
    },

    computed: {
        isValid() {
            let value = this.phone;
            value = value.replace(/[^\w\s]/gi, '').replace(/\s/g, '');

            return value.length >= 10 && value.length <= 11;
        }
    },

    created() {
        this.value = this.phone;
    },

    methods: {
        update(value) {
            value = value.replace(/[^\w\s]/gi, '').replace(/\s/g, '');
            let valid = false;

            if (value.length === 10) {
                valid = true;
                value = '(' + value.slice(0, 3) + ") " + value.slice(3, 6) + '-' + value.slice(6);
            } else if (value.length === 11) {
                valid = true;
                value = value.charAt(0) + ' (' + value.slice(1, 4) + ") " + value.slice(4, 7) + '-' + value.slice(7);
            }

            this.value = value;

            this.$emit('update', { 
                value: this.value,
                valid: valid
            });
        }
    }
};